import React from "react";
import Content from "../components/pagestructure/content";

const ContentPage = () => {
    return (
        <React.Fragment>
            <Content title="Content Page" pic="/images/pic09.jpg" />
        </React.Fragment>        
    );
}

export default ContentPage;